import React, {Fragment} from 'react';
import createEditor, { referenceActionData } from '../form/ComponentEditor';
import Box from '../layout/Box';
import ProgramPriceForm from './forms/ProgramPriceForm';
import ProgramPriceList from './lists/ProgramPriceList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import TicketPriceList from './lists/TicketPriceList';
import TicketPriceForm from './forms/TicketPriceForm';

class TicketPriceEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        let actions = [];
        if (this.props.groupPrices !== undefined) {
            actions = [
                <Button
                    key="0"
                    size="xs"
                    disabled={this.props.isLoading}
                    color="primary"
                    icon={{lib: "fa", name: "plus"}}
                    onClick={this.pristineForm}
                />
            ];
        } else {
            actions = [
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={this.pristineForm}
                >
                    Új
                </Button>
            ];
        }
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Árak"
                    footer={this.props.groupPrices === undefined && actions}
                >
                    <TicketPriceList ref={(el) => this.list = el} {...this.props} actions={actions} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Árszabás"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <TicketPriceForm {...this.props} />
                </Editor>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "TicketPrice",
    WrappedComponent: TicketPriceEditor,
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});
